import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class LegacyWidgetVisibilityService {
  private readonly visible$$ = new BehaviorSubject<boolean>(false);
  readonly visible$: Observable<boolean> = this.visible$$.asObservable();

  set(visible: boolean): void {
    this.visible$$.next(visible);
  }
}
